import React from "react";

export default function BigLoader() {
  return <div className="BigLoaderContainer">
  <div className="BigLoader"></div>
  </div>;
}
